import { Chip, type SxProps, type Theme } from '@mui/material';

import { Request, type PaymentStatus as PaymentStatusType } from '../../models';

interface PaymentStatusProps {
	paymentStatus: PaymentStatusType;
	sx?: SxProps<Theme>;
}

interface StatusStyle {
	color: string;
	border: string;
}

const unknownStatus = 'unknown';

const labels: Record<string, string> = {
	[Request.paymentStatus.fullyPaid]: 'Fully Paid',
	[Request.paymentStatus.unpaid]: 'Unpaid',
	[Request.paymentStatus.depositPaid]: 'Deposit Paid',
	[Request.paymentStatus.paymentError]: 'Error',
	[unknownStatus]: 'Unknown',
};

const style: Record<string, StatusStyle> = {
	[Request.paymentStatus.fullyPaid]: {
		color: 'success.darker',
		border: '1.5px solid #064e3b',
	},
	[Request.paymentStatus.unpaid]: {
		color: 'error.darker',
		border: '1.5px solid #700F2B',
	},
	[Request.paymentStatus.depositPaid]: {
		color: 'secondary.dark',
		border: '1.5px solid #C75507',
	},
	[Request.paymentStatus.paymentError]: {
		color: 'error.dark',
		border: '1.5px solid #C20E2F',
	},
	[unknownStatus]: {
		color: 'grey',
		border: '1.5px solid #8E8E93',
	},
};


export const PaymentStatus = ({ paymentStatus }: PaymentStatusProps) => {
	const resolvedStatus = style[paymentStatus] ? paymentStatus : unknownStatus;

	return (
		<Chip
			label={labels[resolvedStatus]}
			variant="outlined"
			sx={{
				...style[resolvedStatus],
				fontWeight: 'bold',
				width: { xs: 90, sm: 100, md: 110 },
				borderRadius: '14px',
				fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
				'&.MuiChip-root': {
					borderRadius: '5px',
				},
			}}
		/>
	);
};
